import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

abstract class Callback<DesiredResponseType> {
	private fetchStateRelease: (() => void) | undefined;

	// One-shot pairing for list fetching state: the store action that dispatched this
	// request binds a release exactly once. finalize consumes it on the FIRST completion
	// (success, failure or abort). Later completions on a reused callback instance
	// (subscribed-query background reloads re-run the same QueryStoreRequest) are no-ops,
	// so they can never release fetching state they did not acquire.
	public bindFetchStateRelease(release: () => void): void {
		this.fetchStateRelease = release;
	}

	public finalizeCallbackFunction(): void {
		this.releaseFetchState();
	}

	// Subclasses that override finalizeCallbackFunction must call releaseFetchState().
	protected releaseFetchState(): void {
		const release = this.fetchStateRelease;
		this.fetchStateRelease = undefined;
		release?.();
	}

	public uniqueCallbackIdentifier(): string {
		return this.constructor.name;
	}

	protected logFailureResponse(failureResponse: unknown): void {
		console.error('[QueryStore]', this.constructor.name, 'failed:', failureResponse);
	}

	abstract failureCallbackFunction: (failureResponse: unknown) => void;

	abstract successCallbackFunction: (
		successResponse: DesiredResponseType,
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	) => void;
}

export { Callback };
